import React, { FC } from "react";

import { useInsuranceLabels } from "../Utils/Context/labelsContext";
import { BookingForm } from "../View/BookingForm/BookingForm";
import { GenericAppointmentInfo } from "../View/GenericAppointment/GenericAppointmentInfo";
import { GoBack } from "../View/GoBack";
import { GenericAppointmentParams } from "../../../Pages/GenericAppointment/GenericAppointmentParams.csharp";

export const GenericAppointmentPage: FC<GenericAppointmentParams> = (props) => {
  const { locations, services, specializations } = props;

  const { buttons, tabHeadings } = useInsuranceLabels();

  return (
    <div className="insuranceBody insurancePageWithForm">
      <div className="insurancePageWithForm__controls">
        <GoBack label={buttons.goToHomePageButtonLabel} />
      </div>
      <div className="insurancePageWithForm__info">
        <GenericAppointmentInfo
          header={tabHeadings.bookAppointmentTabHeading}
          locations={locations}
        />
      </div>
      <div className="insurancePageWithForm__form">
        <BookingForm
          locations={locations}
          services={services}
          specializations={specializations}
        />
      </div>
    </div>
  );
};
